"use client";

import { useEffect } from 'react';
import { useCartStore } from '../../stores/useCartStore';
import { isAuthenticated } from '../../lib/auth';

export default function CartInitializer() {
  const loadCart = useCartStore((state) => state.loadCart);
  const hasLoadedCart = useCartStore((state) => state.hasLoadedCart);

  useEffect(() => {
    // Load cart on mount if authenticated and not already loaded
    if (!hasLoadedCart && isAuthenticated()) {
      loadCart();
    }
  }, [loadCart, hasLoadedCart]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const refreshCartFromServer = () => {
      if (!isAuthenticated()) return;
      useCartStore.getState().loadCart(true);
    };

    const handleWindowFocus = () => {
      refreshCartFromServer();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshCartFromServer();
      }
    };

    // Keep authenticated carts in sync with updates from other devices.
    const pollInterval = window.setInterval(() => {
      if (document.visibilityState === 'visible') {
        refreshCartFromServer();
      }
    }, 15000);

    window.addEventListener('focus', handleWindowFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.clearInterval(pollInterval);
      window.removeEventListener('focus', handleWindowFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
}

